module.exports = __webpack_public_path__ + "static/headerlogo-f3440bfb9472af744ffd98f420a633a6.png";